import axios from "../api/axios"; // Importing Axios for making HTTP requests

export const stripeVerifySession = async (sessionId) => {
  try {
    // The backend verifySession reads from req.query, so use GET with params.
    // Send both keys (sessionId and session_id) to be tolerant of server expectations.
    const response = await axios.get("/stripe/verify-session", {
      params: { sessionId, session_id: sessionId },
    });

    // Return the parsed JSON payload directly
    return response.data;
  } catch (error) {
    // Re-throw a normalized error so callers can inspect .response or .message
    throw error;
  }
};